import PageWrapper from '@app/components/layout/PageWrapper';
import { FiltersTest } from '@app/components/query-filters/filters-test';
import FullLoader from '@app/components/ui/FullLoader';
import { Suspense } from 'react';

// Route Component
const QueryFiltersTestPage = () => (
  <Suspense fallback={<FullLoader />}>
    <PageWrapper title="Query Filters Test">
      <FiltersTest />
    </PageWrapper>
  </Suspense>
);

// Export Lazy-Loaded Route
export default {
  QueryFiltersTestPage,
};
